import { useNode } from "@craftjs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Switch } from "@/components/shared/switch";

export const AdvancedSettings = () => {
  const { t } = useTranslation();
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props,
  }));

  const handleToggleMuted = useCallback(() => {
    setProp((props) => {
      return (props.isMuted =
        props.isMuted === undefined ? true : !props.isMuted);
    });
  }, [setProp]);

  return (
    <div className="mt-2 flex flex-col items-start justify-between">
      <h2 className="mb-2 text-sm font-medium">
        {t("preference-panel.advanced-settings")}
      </h2>
      <div className="flex flex-row items-center gap-2">
        <Switch
          label={t("preference-panel.mute")}
          defaultChecked={Boolean(props.isMuted)}
          onChange={handleToggleMuted}
        />
        <p className="text-sm">{t("preference-panel.mute")}</p>
      </div>
    </div>
  );
};
